import get from "lodash/get";

/**
 * Fire-and-forget helper — triggers the idempotent migration endpoint for a
 * given athlete ID. Safe to call multiple times; the API no-ops if already run.
 */
export const triggerConfigMigration = (api, userId) => {
  if (!userId) return;
  api(`client-configurations/${userId}/migrate`, { method: "POST" }).catch(
    (err) => console.error("client-config migration failed", err)
  );
};

/**
 * Middleware: triggers migration for the athlete when logged-in user is a coach.
 * Runs after ensureCoach so locals.athlete is already loaded.
 */
export const triggerClientConfigMigration = ({ locals, api }, next) => {
  triggerConfigMigration(api, locals.athlete?._id || locals.activeUser?._id);
  return next();
};

/**
 * Middleware: triggers migration for the logged-in user when they are an athlete.
 * Runs after ensureUser so locals.activeUser is already loaded.
 */
export const triggerClientSelfConfigMigration = ({ locals, api }, next) => {
  const isCoach =
    get(locals, "activeUser.permissions", []).indexOf("coach") > -1;

  if (!isCoach) {
    triggerConfigMigration(api, get(locals, "activeUser._id"));
  }

  return next();
};
